<div [formGroup]="parentForm">
  <wsd-extended-input [control]="parentForm.get(controlName)"
                     label="{{ showLabel ? (label | translate) : '' }}">
    <p-multiSelect [options]="languages"
                   [defaultLabel]=" 'WS_DIRECTORY.PERSON_MODIFY.LANGUAGES_PLACEHOLDER' | translate "
                   [formControlName]="controlName">
    </p-multiSelect>
  </wsd-extended-input>
</div>
